import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/car-available.svg'
import _imports_1 from '@/assets/icons/Cardeck-is-full.svg'


const _hoisted_1 = { class: "cabin-details" }
const _hoisted_2 = {
  key: 0,
  class: "details"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 1,
  class: "details"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 2,
  class: "details"
}
const _hoisted_9 = { class: "vehicle-details" }
const _hoisted_10 = {
  key: 0,
  class: "details"
}
const _hoisted_11 = {
  key: 1,
  class: "details"
}

import { Attribute } from "../models/AvailabilityCalendarTypes";
import { computed } from "vue";

interface Props {
    details?: Attribute;
    hasVehicle?: boolean;
    hasCabin?: boolean;
    showAll?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DateAvailability',
  props: {
    details: {},
    hasVehicle: { type: Boolean },
    hasCabin: { type: Boolean },
    showAll: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const cabins = computed(() => props.details?.customData.cabins ?? 0);

const fitsVehicle = computed(() => props.details?.customData.fitsVehicle);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.showAll || (_ctx.hasCabin && _ctx.details?.customData.class === 'available'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "color available" }, null, -1)),
            (_ctx.showAll)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Many cabins of this type available."))
              : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(cabins.value) + " cabins of this type available.", 1))
          ]))
        : _createCommentVNode("", true),
      (_ctx.showAll || (_ctx.hasCabin && _ctx.details?.customData.class === 'almost-full'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "color almost-full" }, null, -1)),
            (_ctx.showAll)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Few cabins of this type available."))
              : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(cabins.value) + " cabins of this type available.", 1))
          ]))
        : _createCommentVNode("", true),
      (_ctx.showAll || (_ctx.hasCabin && _ctx.details?.customData.class === 'no-cabin'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, _cache[2] || (_cache[2] = [
            _createElementVNode("div", { class: "color no-cabin" }, null, -1),
            _createElementVNode("span", null, "No cabins of this type available.", -1)
          ])))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_9, [
      (_ctx.showAll || (_ctx.hasVehicle && fitsVehicle.value))
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, _cache[3] || (_cache[3] = [
            _createElementVNode("div", { class: "icon" }, [
              _createElementVNode("img", {
                src: _imports_0,
                class: "icon__svg"
              })
            ], -1),
            _createElementVNode("span", null, "Vehicle space available.", -1)
          ])))
        : _createCommentVNode("", true),
      (_ctx.showAll || (_ctx.hasVehicle && !fitsVehicle.value))
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, _cache[4] || (_cache[4] = [
            _createElementVNode("div", { class: "icon" }, [
              _createElementVNode("img", {
                src: _imports_1,
                class: "icon__svg"
              })
            ], -1),
            _createElementVNode("span", null, "No vehicle space available.", -1)
          ])))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})